import type { ComponentProps } from 'react'
import type { ResponsiveImage } from '~/lib/media/images'

type ImgProps = Omit<ComponentProps<'img'>, 'src' | 'srcSet'> & {
  image: ResponsiveImage
  /** Rendered width hint, e.g. "(min-width: 992px) 50vw, 100vw". */
  sizes: string
  /** Above-the-fold images: load eagerly with high priority. */
  priority?: boolean
}

/** Responsive <img> for `?responsive` imports. */
export function Img({ image, sizes, priority = false, ...props }: ImgProps) {
  const srcSet = Object.values(image.sources)[0]
  return (
    <img
      src={image.img.src}
      srcSet={srcSet}
      sizes={sizes}
      width={image.img.w}
      height={image.img.h}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      {...props}
    />
  )
}
